var ReactSelect = require("react-select");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var Glyphicon = require("components/utility/icons/Glyphicon");

class SchoolSearch extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			loading: true, searchTimer: null
		};
	}

	selectSchool(selectedSchool) {
		if (selectedSchool == null) {
			this.props.onSelect(null);
		} else if (selectedSchool.value == SchoolSearch.MANUAL_ENTRY) {
			this.props.toggleManual();
		} else {
			this.props.onSelect(selectedSchool);
		}
	}

	setSchoolSearchTimer(input, callback) {
		if (this.state.searchTimer) {
			clearTimeout(this.state.searchTimer);
		}
		this.state.searchTimer = setTimeout(this.getSchoolOptions, 500, input, callback);
	}

	getSchoolOptions(input, callback) {
		var searchParams = { q: input.trim(), embed: "school.district,school.demographic_bucket" };
		var url = WhooosReadingServices.CanonicalSchools.url("/search", searchParams);

		if (input.trim().length == 0) {
			callback(null, { options: [] });
			return;
		}

		$.getJSON(url, function(data) {
			var options = _.map(data.schools, function(school) {
				return { value: school, label: school.name + " (" + school.zip + ")" }
			});

			options.push({ value: SchoolSearch.MANUAL_ENTRY, label: input.trim() });

			callback(null, { options: options });
		});
	}

	optionRenderer(optionData, index) {
		if (optionData.value == SchoolSearch.MANUAL_ENTRY) {
			return (
				<span className="searchOpDisplay text-center">
					<span>
						Not finding your school? Try ZIP code or {" "}
						<a href="#" onClick={ $wr.nope }>
							add it manually.
						</a>
					</span>
				</span>
			);

		} else {
			return (
				<span className="schoolOpDisplay">
					{ optionData.label }
				</span>
			);
		}
	}

	render() {
		var placeholderText = "Search by ZIP code (or school name)";

		return (
			<div className="schoolSearch">
				<ReactSelect.Async name="school-name" autoload={ false }
					optionRenderer={this.optionRenderer} keepInputCase={ true }
					value={ this.props.selectedSchool } placeholder={ placeholderText }
					loadOptions={ this.setSchoolSearchTimer } onChange={ this.selectSchool } />
			</div>
		)
	}
};

SchoolSearch.NOT_PRESENT = "not-present";

SchoolSearch.MANUAL_ENTRY = "manaul-entry";

SchoolSearch.propTypes = StrictPropTypes({
	toggleManual: PropTypes.func,
	selectedSchool: PropTypes.object,
	onSelect: PropTypes.func,

});

module.exports = SchoolSearch;



// WEBPACK FOOTER //
// ./modules/components/org/roster/SchoolSearch.js